// extracted by mini-css-extract-plugin
export default {"title":"U6ZHUkzG","description":"Q5JOFqzb"};